import "../css/bootstrap.css";
import "../css/MainAfroEstetica.css";
import AfroEsteticaCarrossel from "./afroEsteticaCarrossel";

function MainAfroEstetica() {
  return (

    <div className="row" id="imgs1">
      <div className="col-12 w-100">
        <AfroEsteticaCarrossel />
      </div>
    </div>  
      );
}
export default MainAfroEstetica;
